/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
/* eslint-disable no-console */

/**
 * Adds transparent header styles on homepage when banner is visible
 */
document.addEventListener('DOMContentLoaded', function () {
  const isHomePage = document.querySelector('.page[data-action="Home-Show"]');
  const header = document.querySelector('.transparent-header-home');
  const menus = document.querySelectorAll('.transparent-menu');
  const mobileMenu = document.querySelector('.primary-category-slider');
  const banner = document.querySelector('.header-banner');
  const searchInput = document.querySelector('.site-search input.form-control');

  let isBannerVisible = false;
  let isHeaderHovered = false;
  let isSearchActive = false;

  if (!header || menus.length === 0 || !banner) {
    return;
  }

  function setInitialState() {
    try {
      if (header) {
        header.classList.remove('t-header');
      }
      menus.forEach(function (menu) {
        menu.classList.remove('t-menu');
      });
      mobileMenu.classList.remove('t-menu');
    } catch (err) {
      console.error('Error while applying initial state', err);
    }
  }

  function updateStyles() {
    try {
      if (isHomePage && (isHeaderHovered || !isBannerVisible || isSearchActive)) {
        // Apply normal styles (when hovered OR banner not visible)
        header.classList.remove('t-header');
        mobileMenu.classList.remove('t-menu');
        menus.forEach(function (menu) {
          menu.classList.remove('t-menu');
        });
      } else {
        // Apply transparent styles (when banner visible AND not hovered)
        header.classList.add('t-header');
        mobileMenu.classList.add('t-menu');
        menus.forEach(function (menu) {
          menu.classList.add('t-menu');
        });
      }
    } catch (err) {
      setInitialState();
      console.error('transparentHeader updateStyles error', err);
    }
  }

  setInitialState();

  // Add hover event listeners
  header.addEventListener('mouseenter', function () {
    isHeaderHovered = true;
    updateStyles();
  });

  header.addEventListener('mouseleave', function () {
    isHeaderHovered = false;
    updateStyles();
  });

  if (searchInput) {
    searchInput.addEventListener('focus', function () {
      isSearchActive = true;
      updateStyles();
    });

    searchInput.addEventListener('blur', function () {
      isSearchActive = false;
      updateStyles();
    });
  }

  // Intersection Observer to monitor banner visibility
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target === banner) {
        isBannerVisible = entry.isIntersecting;
        updateStyles();
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });
  observer.observe(banner);

  // Debounce function to limit how often a function can fire
  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  // Update CSS variable for header height
  function updateHeaderHeight() {
    try {
      const pageHeader = document.querySelector('header');
      if (!pageHeader || !document.documentElement) return;
      const h = Math.ceil(pageHeader.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty('--header-height', h + 'px');
    } catch (e) {
      console.error('updateHeaderHeight error', e);
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', debounce(updateHeaderHeight, 100));

  window.addEventListener('beforeunload', function () {
    observer.disconnect();
    if (searchInput) {
      searchInput.removeEventListener('focus', function () {});
      searchInput.removeEventListener('blur', function () {});
    }
  });
});
